import React from 'react';
import renderer from 'react-test-renderer';
import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';
import {
  account, accountTypes, userLicenses, user,
} from '../../__mocks__/account-data';

import Edit from '../../../admin/users/Edit';

const userRoles = [{ id: 1, name: 'Role_1' }, { id: 2, name: 'Role_2' }];

global.fetch = jest.fn().mockResolvedValueOnce({ json: () => Promise.resolve({ }) });

it('renders correctly with props', () => {
  const tree = renderer.create(
    <Edit
      account={account}
      user={user}
      user_licenses={userLicenses}
      roles={userRoles}
      accountTypes={accountTypes}
    />,
  ).toJSON();
  expect(tree).toMatchSnapshot();
});

it('renders correctly without props', () => {
  const tree = renderer.create(<Edit />).toJSON();
  expect(tree).toMatchSnapshot();
});

it('updates state when input fields are changed', () => {
  render(
    <Edit
      account={account}
      user={user}
      user_licenses={userLicenses}
      roles={userRoles}
      accountTypes={accountTypes}
    />,
  );

  const inputs = screen.getAllByPlaceholderText('Type Here');
  const firstNameInput = inputs[0];
  const lastNameInput = inputs[1];
  const emailInput = inputs[2];
  fireEvent.change(firstNameInput, { target: { value: 'New First Name' } });
  expect(firstNameInput.value).toBe('New First Name');

  fireEvent.change(lastNameInput, { target: { value: 'New Last Name' } });
  expect(lastNameInput.value).toBe('New Last Name');

  fireEvent.change(emailInput, { target: { value: 'new@gmail.com' } });
  expect(emailInput.value).toBe('new@gmail.com');
});

it('disables the button when required fields are empty', () => {
  render(<Edit />);
  const button = screen.getByRole('button', { name: /create user/i });
  expect(button).toBeDisabled();
});
